import { createUseStyles } from 'react-jss'

import { black } from '../../../../../../../styles/const/colors'
import { listBorderColor, listColPadding } from '../../../../../List/styles'

const useStyles = createUseStyles({
  attributionsTitle: {
    color: black,
    textAlign: 'left',
    paddingLeft: listColPadding,
    paddingTop: 8,
    paddingBottom: 8
  },
  attributionRow: {
    paddingRight: 0,
    paddingLeft: 0,
    color: black,

    '&:first-child': {
      borderTop: `1px solid ${listBorderColor}`
    }
  },
  summaryRow: {
    fontWeight: 700
  }
})

export default useStyles
